export interface Storage {
  getItem(name: string): string | null | Promise<string | null>
  setItem(name: string, value: string): void | Promise<void>
  removeItem(name: string): void | Promise<void>
}

export interface BrowserStorageOptions {
  area?: "local" | "session"
  namespace?: string
  storage?: globalThis.Storage
}

export function createBrowserStorage(options: BrowserStorageOptions = {}): Storage {
  const namespace = normalizeNamespace(options.namespace)
  const storage =
    options.storage ?? ((options.area ?? "local") === "session" ? globalThis.sessionStorage : globalThis.localStorage)

  if (storage == null) {
    throw new Error("Browser storage is not available in this host.")
  }

  return {
    getItem: (name) => storage.getItem(createKey(namespace, name)),
    setItem: (name, value) => storage.setItem(createKey(namespace, name), value),
    removeItem: (name) => storage.removeItem(createKey(namespace, name)),
  }
}

export function createMemoryStorage(initialValues: Readonly<Record<string, string>> = {}): Storage {
  const values = new Map(Object.entries(initialValues))

  return {
    getItem: (name) => values.get(name) ?? null,
    setItem: (name, value) => {
      values.set(name, value)
    },
    removeItem: (name) => {
      values.delete(name)
    },
  }
}

function normalizeNamespace(namespace?: string) {
  const value = namespace?.trim()
  return value == null || value.length === 0 ? undefined : value
}

function createKey(namespace: string | undefined, name: string) {
  return namespace == null ? name : `${namespace}:${name}`
}
